import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import ExternalLink from 'components/Widgets/ExternalLink';
import TeamProfile from 'components/Managers/Dashboard/Views/CpaDetails/TeamProfile';

import { useContext as useUsersContext } from 'components/Users/Context';

import { Link } from 'react-router-dom';

export default function Index() {
  const [growthReport, setGrowthReport] = useState(null);

  const { dispatch: dispatchUsers, state: stateUser, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  useEffect(() => {
    axios
      .get(routes.api.members.growth_reports.latest)
      .then((response) => {
        setGrowthReport(response.data.data);
      });
  }, []);

  if (growthReport === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="content">
      <section>
        <Row className="align-items-center">
          <Col>
            <h1>Growth Report</h1>
          </Col>

          {stateUser.user && !stateUser.user.attributes.is_mobile_login && (
            <Col sm="auto" className="mt-3 mt-sm-0">
              <ExternalLink
                href={growthReport.attributes.url}
              >
                Download
              </ExternalLink>
            </Col>
          )}
        </Row>
      </section>

      <section>
        <h4 className="mb-3">Your Growth Report is Ready!</h4>

        <p>
          The Growth Report provides a comprehensive view of your development attained during
          {' '}
          the coaching engagement, indicating your positive growth and increased awareness
          {' '}
          across all twelve dimensions of Productivity and Wellbeing.
        </p>
      </section>

      <section>
        <h4 className="mb-3">Assessment Results</h4>

        <Row>
          <Col lg={6} className="mb-3">
            <TeamProfile
              title="Productivity"
              data={growthReport.attributes.productivity_results}
              variant="primary"
            />
          </Col>

          <Col lg={6} className="mb-3">
            <TeamProfile
              title="Wellbeing"
              data={growthReport.attributes.wellbeing_results}
              variant="secondary"
            />
          </Col>
        </Row>

        {stateUser.user && stateUser.user.attributes.is_mobile_login && (
          <footer className="d-flex justify-content-end mt-3">
            <Link className="btn btn-primary" to={routes.members.webview.finish}>
              Next
            </Link>
          </footer>
        )}

      </section>

    </div>
  );
}
